module.exports = __webpack_public_path__ + "media/acuity/sector-9b89e58f.svg";